import React from "react";

export default ({title, dataKey, data, dataHandler}) => {
  let value = '-';

  if (dataHandler) {
    value = dataHandler(data) || '-';
  } else if (dataKey) {
    value = data[dataKey] || '-';
  }

  return (
    <div>
      <h3 className="f16 lh24 fw7 p0 m0">{title}</h3>
      <span className="dB mt18 f12 lh18 fw4 c595B5E">
        {value}
      </span>
    </div>
  )
};
